import { Space, Button, Form, List, NavBar } from "antd-mobile";
import RemoteListPicker from "../mobiledpi/RemoteListPicker";
import { api } from "../common/api";
import { useNavigate } from "react-router";
import { requiredField } from "../common/common";

export default function PickEquipment() {
  const navigate = useNavigate();
  return (
    <Space direction="vertical" block>
      <NavBar onBack={() => navigate("..", { replace: true })} style={{ background: "#FFF" }}>
        Seleziona attrezzatura
      </NavBar>
      <Form
        layout={"horizontal"}
        onFinish={(val) => navigate("/mobile/equipments/" + val.equipment.value)}
        footer={
          <Button block color="primary" type="submit">
            Avanti
          </Button>
        }
      >
        <Form.Item
          name="equipment"
          label={"Attrezzatura"}
          rules={[requiredField]}
          onClick={(e, ref) => ref.current?.open()}
        >
          <RemoteListPicker
            fetchItem={qr => api.equipment.get(qr.match(/EQ-(\d+)/)?.[1])}
            fetchList={api.equipment.list}
            title={"Seleziona attrezzatura"}
            placeholder={"Seleziona attrezzatura"}
            labelFn={(item) => item.serialCode + " " + item.description}
            valueFn={(x) => x.id}
          />
        </Form.Item>
      </Form>
    </Space>
  );
}
